import './TournamentButton.scss';
import tournamentIcon from '../../../../../assets/images/tournament-icon.png';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { tournamentStore } from '../../../../../platform/stores';

export const TournamentButton = observer(() => {
  const [countdown, setCountdown] = useState<string>('0h 0m');

  useEffect(() => {
    const calculateCountdown = () => {
      if (!tournamentStore.activeTournament?.endedAt) {
        setCountdown('0h 0m');
        return;
      }

      const endDate = new Date(tournamentStore.activeTournament.endedAt);
      const now = new Date();
      const timeDifference = endDate.getTime() - now.getTime();

      if (timeDifference <= 0) {
        setCountdown('Ended');
        return;
      }

      const hours = Math.floor(timeDifference / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      // Format: "Xh Ym" or "Xm Ys" or "Ys"
      if (hours > 0) {
        setCountdown(`${hours}h ${minutes}m`);
      } else if (minutes > 0) {
        setCountdown(`${minutes}m ${seconds}s`);
      } else {
        setCountdown(`${seconds}s`);
      }
    };

    // Calculate immediately
    calculateCountdown();

    // Update every second
    const interval = setInterval(calculateCountdown, 1000);

    return () => clearInterval(interval);
  }, [tournamentStore.activeTournament?.endedAt]);

  return (
    <div className="tournament-button" onClick={() => tournamentStore.setMainModalIsOpened(true)}>
      <img src={tournamentIcon} alt="Tournament icon"/>
      <div className="countdown">
        {countdown}
      </div>
    </div>
  );
});